<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">Cancel booking #{{ data.bookingId }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <div class="field">
      <span class="field-label">Reason</span>
      <mat-form-field appearance="outline">
        <mat-select formControlName="cancelCode">
          @for(r of reasons; track r.reasonCode){
          <mat-option [value]="r.reasonCode">{{ r.reasonName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field">
      <span class="field-label">Description</span>
      <textarea class="text-box-active" rows="3" formControlName="cancelDesc"></textarea>
    </div>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-danger-btn" (click)="submit()">Cancel booking</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
